import React, { Component, createRef } from 'react';
import { Modal as ModalRs, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip, faSmile, faCheckDouble, faCheck, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import Foto from '../../assets/images/login-v2.png';
import CustomFileMessage from './componentChat/CustomFileMessage';
import { requestData, requestChat } from '../../helper/request';
import requestMessage from '../../helper/requestMessage';
import { IMG_HOST, VITE_API_MESSAGE, VITE_COMPANY_ID, VITE_IMG_MESSAGE_HOST } from '../../helper/host';
import { createWebSocketURL } from '../../helper/webSocket';
import { connect } from 'react-redux';

class ChatCs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: false,
      passwordCustomer: '',
      companyId: null,
      conversationId: null,
      newConversations: [],
      conversations: [],
      image: null,
      messages: [],
      isTyping: false,
      file: false,
      sendFileImage: false,
      message: '',
      email: 'ipresens.com@gmail.com',
      pass: props.pass || '123456789',
      uploadImage: false,
      participants: [],
      isOnline: true,
      conversation: [],
      user: localStorage.getItem('Presensi-Auth-User'),
      data_message: localStorage.getItem('data-message-user'),
    };

    this.socketRef = createRef();
    this.socketConversation = createRef();
    this.retryCountRef = 0;
    this.pingIntervalRef = null;
    this.messagesEndRef = createRef();
    this.maxRetries = 5;
    this.retryDelay = 3000;
    this.onlineInterval = null;
    this.lastStatus = null;
  }

  loadCompany = () => {
    const form = {};
    this.props
      .request('get_company', form, 'POST')
      .then((response) => {
        if (response && response.success) {
          this.setState({ passwordCustomer: response.data.perusahaan_chat_password });
          this.getChannel();
        }
      })
      .catch((error) => {
        console.error('Error loading company data:', error);
      });
  };

  handleFile = () => {
    this.setState((prevState) => ({
      file: !prevState.file,
    }));
  };

  componentDidMount() {
    const storedPassword = localStorage.getItem('data-message-user');
    const storedLoggedIn = localStorage.getItem('token-message');
    this.loadCompany();

    if (this.onlineInterval) {
      clearInterval(this.onlineInterval);
      this.onlineInterval = null;
    }

    if (this.state.conversationId) {
      this.changeOnlineStatus(this.state.conversationId, false);
    }

    this.registerCustomer();
  }

  componentDidUpdate(prevProps, prevState) {
    const { openChat, pass } = this.props;
    const { conversationId, companyId, messages } = this.state;

    if (openChat && !prevProps.openChat && conversationId) {
      this.changeOnlineStatus(conversationId, true);

      if (!this.onlineInterval) {
        this.onlineInterval = setInterval(() => {
          this.changeOnlineStatus(conversationId, true);
        }, 60000);
      }
    }

    if (!openChat && prevProps.openChat && conversationId) {
      this.changeOnlineStatus(conversationId, false);

      if (this.onlineInterval) {
        clearInterval(this.onlineInterval);
        this.onlineInterval = null;
      }
    }

    if (openChat && !prevProps.openChat && !companyId) {
      this.loadCompany();
    }

    if (messages.length !== prevState.messages.length) {
      this.scrollToBottom();
    }

    if (pass !== prevProps.pass) {
      this.setState({ pass });
    }
  }

  loginCustomer = () => {
    const form = {
      email: this.props.user.perusahaan.perusahaan_email,
      password: '123',
      companyID: VITE_COMPANY_ID,
    };

    requestChat(VITE_API_MESSAGE, `customers/login`, form, 'POST')
      .then((response) => {
        if (response && response.success) {
          const dataMessage = response.data;
          const tokenMessage = response.token;
          localStorage.setItem('data-message-user', JSON.stringify(dataMessage));
          localStorage.setItem('token-message', tokenMessage);
          this.setState({ data_message: dataMessage });
          if (tokenMessage) {
            this.getChannel();
          }
        }
        this.setState({ isLoggedIn: true });
      })
      .catch((error) => {
        console.error('Error logging in customer:', error);
        this.setState({ isLoggedIn: false });
      });
  };

  registerCustomer = () => {
    const { user } = this.props;
    const perusahaan = user?.perusahaan;

    const form = {
      name: perusahaan?.perusahaan_nama,
      email: perusahaan?.perusahaan_email,
      password: '123',
      customerId: '20' + perusahaan?.perusahaan_id,
      customerCode: '20' + perusahaan?.perusahaan_id,
      credential: 'user',
      companyID: VITE_COMPANY_ID,
    };

    requestChat(VITE_API_MESSAGE, `customers`, form, 'POST')
      .then((response) => {
        if (response && response.success) {
          const dataMessage = response.data;
          const tokenMessage = response.token;
          localStorage.setItem('data-message-user', JSON.stringify(dataMessage));
          localStorage.setItem('token-message', tokenMessage);
          this.setState({ data_message: dataMessage });
          if (tokenMessage) {
            this.getChannel();
          }
          this.update();
        } else {
          this.loginCustomer();
        }
      })
      .catch((error) => {
        console.error('Error registering customer:', error);
      });
  };

  getChannel = () => {
    requestMessage
      .GET('channels', { companyID: VITE_COMPANY_ID })
      .then((response) => {
        if (response && response.success) {
          const channelId = response.channels[0]?._id;
          this.setState({ companyId: channelId });
          if (channelId) {
            this.getConversation(channelId);
          }
        }
      })
      .catch((error) => {
        console.error('Error getting channel:', error);
      });
  };

  getConversation = (channel) => {
    requestMessage
      .GET('conversation', { page: 1, channel })
      .then((response) => {
        if (response && response.success) {
          const filteredData = response.data.filter((conversation) => conversation.participants.length > 1);
          const conversationIds = response.data.map((item) => item._id);
          const conversationString = conversationIds.join(',');
          const token = localStorage.getItem('token-message');

          this.setState({ participants: filteredData, conversationId: conversationString });

          this.getChatWs(conversationString, token);
          this.getConvesationWs(token);
          if (this.state.conversationId) {
            this.changeOnlineStatus(conversationString, this.state.isOnline);
            this.handleChatRead(conversationString);
          }
          if (response.pagination.total === 0) {
            this.createConversation(channel);
          }
        }
      })
      .catch((error) => {
        console.error('Error getting conversation:', error);
      });
  };

  createConversation = (channel) => {
    const parsed = this.state.data_message || {};
    const form = {
      emailTarget: 'ipresens.com@gmail.com',
      channelID: channel,
      namespace: '',
      title: parsed.name,
      lastChat: 'ini ada kendala',
      companyID: VITE_COMPANY_ID,
    };
    requestMessage
      .POST('conversation', form)
      .then((response) => {
        if (response && response.success) {
          this.getConversation(channel);
        }
      })
      .catch((error) => {
        console.error('Error creating conversation:', error);
      });
  };

  getChatWs = (id, token) => {
    if (!id) return;

    if (this.socketRef.current) {
      this.socketRef.current.close();
      this.socketRef.current = null;
    }

    if (this.pingIntervalRef) {
      clearInterval(this.pingIntervalRef);
      this.pingIntervalRef = null;
    }

    createWebSocketURL('chats/ws', token, { conversationId: id })
      .then((responseURL) => {
        const socket = new WebSocket(responseURL);

        this.socketRef.current = socket;

        socket.onopen = () => {
          this.retryCountRef = 0;

          this.pingIntervalRef = setInterval(() => {
            if (socket.readyState === WebSocket.OPEN) {
              socket.send(JSON.stringify({ type: 'ping' }));
            }
          }, 60000);
        };

        socket.onmessage = (event) => {
          const receivedMessage = JSON.parse(event.data);

          if (receivedMessage.type === 'conversation_updated') {
            this.setState({
              conversation: {
                id: receivedMessage.data._id,
                status: receivedMessage.data.status,
                archived: receivedMessage.data.isArchived,
                isOnline: false,
                lastChatDate: receivedMessage.data.lastChatDate,
              },
            });
          } else if (receivedMessage.type === 'typing') {
            this.setState({ isTyping: receivedMessage.data.isTyping });
          } else if (receivedMessage.type === 'chat_created' || receivedMessage.type === 'initial_chat') {
            this.setState((prevState) => {
              const newMessages = Array.isArray(receivedMessage.data) ? receivedMessage.data : [receivedMessage.data];

              const uniqueMessages = newMessages.filter((newMsg) => !prevState.messages.some((existingMsg) => existingMsg._id === newMsg._id));

              if (uniqueMessages.length === 0) return null;

              const merged = [...prevState.messages, ...uniqueMessages];
              merged.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

              return { messages: merged };
            });
          }
        };

        socket.onerror = (error) => {
          console.error('WebSocket chat error:', error);
        };

        socket.onclose = (event) => {
          console.warn('Chat socket closed:', event.reason);

          if (this.pingIntervalRef) {
            clearInterval(this.pingIntervalRef);
            this.pingIntervalRef = null;
          }

          this.changeOnlineStatus(id, false);

          if (this.retryCountRef < this.maxRetries) {
            const delay = Math.min(1000 * Math.pow(2, this.retryCountRef), this.retryDelay);
            setTimeout(() => {
              this.retryCountRef += 1;
              this.getChatWs(id, token);
            }, delay);
          }
        };
      })
      .catch((error) => {
        console.error('Error creating WebSocket URL for chat:', error);
      });
  };

  getConvesationWs = (token) => {
    if (this.socketConversation.current) {
      this.socketConversation.current.close();
      this.socketConversation.current = null;
    }

    if (this.pingIntervalRef) {
      clearInterval(this.pingIntervalRef);
      this.pingIntervalRef = null;
    }

    createWebSocketURL('conversation/ws', token)
      .then((URL) => {
        const socket = new WebSocket(URL);
        this.socketConversation.current = socket;

        socket.onopen = () => {
          this.retryCountRef = 0;

          this.pingIntervalRef = setInterval(() => {
            if (socket.readyState === WebSocket.OPEN) {
              socket.send(JSON.stringify({ type: 'ping' }));
            }
          }, 60000);
        };

        socket.onmessage = (event) => {
          const receivedMessage = JSON.parse(event.data);

          if (receivedMessage.type === 'pong' || receivedMessage.type === 'typing') return;

          if (receivedMessage.status && receivedMessage.data) {
            this.setState((prevState) => {
              const existingConv = prevState.conversations.find((conv) => conv._id === receivedMessage.data._id);

              if (!existingConv || JSON.stringify(existingConv) !== JSON.stringify(receivedMessage.data)) {
                const updatedConversations = [
                  ...prevState.conversations.filter((conv) => conv._id !== receivedMessage.data._id),
                  receivedMessage.data,
                ].sort((a, b) => new Date(b.lastChatUpdate) - new Date(a.lastChatUpdate));

                return { conversations: updatedConversations };
              }

              return null;
            });
          }
        };

        socket.onerror = (error) => {
          console.error('Conversation WebSocket error:', error);
        };

        socket.onclose = (event) => {
          console.warn('Conversation socket closed:', event.reason);

          if (this.pingIntervalRef) {
            clearInterval(this.pingIntervalRef);
            this.pingIntervalRef = null;
          }

          if (this.retryCountRef < this.maxRetries) {
            const delay = Math.min(1000 * Math.pow(2, this.retryCountRef), this.retryDelay);
            setTimeout(() => {
              this.retryCountRef += 1;
              this.getConvesationWs(token);
            }, delay);
          }
        };
      })
      .catch((error) => {
        console.error('Error creating WebSocket URL for conversation:', error);
      });
  };

  handleSend = () => {
    const formData = {
      companyId: this.state.companyId,
      conversationId: this.state.conversationId,
      text: this.state.image && !this.state.message ? '' : this.state.message,
      images: this.state.image ? [this.state.image.file] : [],
    };

    requestMessage
      .POST('chats', formData)
      .then((response) => {
        if (response && response.success) {
          this.setState({
            message: '',
            file: false,
            image: null,
          });
        }
      })
      .catch((error) => {
        console.error('Error sending message:', error);
      });
  };

  handleChatRead = (chat_id) => {
    requestMessage
      .GET(`chats/read/${chat_id}`)
      .then((response) => {
        if (response && response.success) {
        }
      })
      .catch((error) => {
        console.error('Error marking chat as read:', error);
      });
  };

  changeOnlineStatus = async (conversation, status) => {
    if (this.lastStatus === status) return;
    this.lastStatus = status;

    const form = {
      conversationId: conversation,
      isOnline: this.lastStatus,
    };
    const response = await requestMessage.POST('conversation/online', form);
    if (response && response.success) {
      this.setState({});
    }
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  groupMessagesByDay(messages) {
    if (!Array.isArray(messages)) {
      return {};
    }

    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'];
    const dayNames = ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'];
    return messages.reduce((acc, message) => {
      const currentDate = new Date();
      const messageDate = new Date(message.createdAt);

      const currentDateMidnight = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
      const messageDateMidnight = new Date(messageDate.getFullYear(), messageDate.getMonth(), messageDate.getDate());

      const diffTime = currentDateMidnight - messageDateMidnight;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

      let dateLabel;
      if (diffDays === 0) {
        dateLabel = 'Hari ini';
      } else if (diffDays === 1) {
        dateLabel = 'Kemarin';
      } else {
        const dayName = dayNames[messageDate.getDay()];
        const date = messageDate.getDate();
        const monthName = monthNames[messageDate.getMonth()];
        dateLabel = `${dayName}, ${date} ${monthName}`;
      }

      if (!acc[dateLabel]) {
        acc[dateLabel] = [];
      }
      acc[dateLabel].push(message);
      return acc;
    }, {});
  }

  getGroupedMessages() {
    return this.groupMessagesByDay(this.state.messages);
  }

  isSender = (id) => {
    const parsedDataMessage = this.state.data_message || {};
    return parsedDataMessage.email === id;
  };

  isOnline = (channel) => {
    const parsedDataMessage = this.state.data_message || {};
    const receiver = channel.find((participant) => participant.userID._id !== parsedDataMessage.id);
    return receiver?.isOnline === true;
  };

  getTimeFromMessage = (date) => {
    const sendedAtDate = new Date(date);
    return sendedAtDate.toLocaleTimeString('id-ID', {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  scrollToBottom = () => {
    if (this.messagesEndRef.current) {
      this.messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  handleClose = () => {
    const { closeChat } = this.props;

    if (this.socketRef.current) {
      this.socketRef.current.close();
      this.socketRef.current = null;
    }

    if (this.pingIntervalRef) {
      clearInterval(this.pingIntervalRef);
      this.pingIntervalRef = null;
    }

    if (this.state.conversationId) {
      this.changeOnlineStatus(this.state.conversationId, false);
    }

    closeChat();
    this.setState({ file: false, image: null });
  };

  render() {
    const { openChat } = this.props;
    return (
      <ModalRs
        isOpen={openChat}
        toggle={() => {
          this.setState({ image: null });
          this.handleClose();
        }}
        size="lg"
        centered
      >
        <ModalHeader closeButton>
          <div className="d-flex gap-2 align-items-center">
            <img src={Foto} alt="avatar" className="rounded-circle" width={40} height={40} />
            <div>
              <h6 className="mb-0">iPresens Support</h6>
              {this.state.conversations.length > 0 ? (
                this.state.conversations.map((conv, idx) => {
                  const online = this.isOnline(conv.participants);
                  return (
                    <small key={idx} className={`text-${online ? 'success' : 'secondary'}`}>
                      {online ? 'Online' : 'Offline'}
                    </small>
                  );
                })
              ) : (
                <small className="text-secondary">Offline</small>
              )}
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          <div
            className="chat-box overflow-auto"
            style={{
              maxHeight: 'calc(100vh - 300px)',
              overflowY: 'auto',
              paddingBottom: '1rem',
            }}
          >
            {this.state.messages.length === 0 ? (
              <div className="text-center text-muted">Tidak ada chat.</div>
            ) : (
              <div>
                {Object.keys(this.getGroupedMessages()).map((date) => {
                  return (
                    <div className="my-2" key={date}>
                      <div className="d-flex align-items-center mb-3">
                        <hr className="w-100 border-gray-300" />
                        <p className="text-center text-muted mx-3 mb-0" style={{ fontSize: '0.75rem' }}>
                          {date}
                        </p>
                        <hr className="w-100 border-gray-300" />
                      </div>

                      {this.getGroupedMessages()[date].map((message) => {
                        const Sender = this.isSender(message.email);

                        return (
                          <div className={`d-flex flex-column mb-2 ${Sender ? 'align-items-end' : 'align-items-start'}`} key={message._id}>
                            <div className={`d-flex flex-column ${Sender ? 'align-items-end' : 'align-items-start'}`} style={{ maxWidth: '90%' }}>
                              <div
                                className={`p-2 rounded-top ${
                                  Sender ? 'bg-primary text-white rounded-bottom-left' : 'bg-light rounded-bottom-right'
                                }`}
                                style={{ maxWidth: '100%', wordWrap: 'break-word' }}
                              >
                                {Array.isArray(message.images) && message.images.length > 0 && (
                                  <div className="mb-2" style={{ maxWidth: '10rem', maxHeight: '10rem' }}>
                                    <img src={`${VITE_IMG_MESSAGE_HOST}${message.images[0]}`} alt={message.images[0]} className="img-fluid rounded" />
                                  </div>
                                )}

                                <p className={`mb-0 ${Sender ? 'text-white' : 'text-black'}`} style={{ fontSize: '0.875rem' }}>
                                  {message.text}
                                </p>
                              </div>
                            </div>
                            <div className={`d-flex align-items-center mt-1 ${Sender ? 'justify-content-end' : 'justify-content-start'}`}>
                              <small className="text-muted" style={{ fontSize: '0.75rem' }}>
                                {this.getTimeFromMessage(message.sendedAt)}
                              </small>
                              {Sender && (
                                <FontAwesomeIcon
                                  icon={faCheckDouble}
                                  className={`ms-1 ${message.isRead ? 'text-primary' : 'text-secondary'}`}
                                  style={{ fontSize: '0.9rem' }}
                                />
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            )}
            <div ref={this.messagesEndRef}></div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="container-fluid px-0">
            <div className="row align-items-center no-gutters">
              {this.state.file && (
                <div className="col-12 mb-2">
                  <CustomFileMessage
                    classNamePreview="max-w-16"
                    handleClose={() => {
                      this.setState({ image: null });
                      this.handleFile();
                    }}
                    setImg={(img) => this.setState({ image: img })}
                  />
                </div>
              )}
              <div className="col-auto mr-2">
                <button className="btn btn-light" onClick={this.handleFile}>
                  <FontAwesomeIcon icon={faPaperclip} />
                </button>
              </div>
              <div className="col">
                <input
                  type="text"
                  name="message"
                  className="form-control"
                  placeholder="Type a message..."
                  value={this.state.message}
                  onChange={this.handleChange}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      this.handleSend();
                    }
                  }}
                />
              </div>
              <div className="col-auto ml-2">
                <button className="btn btn-primary" onClick={this.handleSend}>
                  <FontAwesomeIcon icon={faPaperPlane} />
                </button>
              </div>
            </div>
          </div>
        </ModalFooter>
      </ModalRs>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.Auth.user,
  api_token: state.Auth.api_token,
});
export default connect(mapStateToProps)(ChatCs);
